import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {IdentiteService} from "../../../identite/shared/services/identite.service";
import {AlertService} from "../../services/alert.service";
import {Role} from "../../../identite/shared/classes/role";

@Component({
  selector: 'app-select-role',
  templateUrl: './select-role.component.html',
  styleUrls: ['./select-role.component.css']
})
export class SelectRoleComponent implements OnInit {

  @Input()  aclRole:    string = null;
  @Input()  value:      string = null;
  @Input()  toExclude:  string[] = [];

  @Output() valueChange = new EventEmitter<string>();

  roles: Role[] = [];

  constructor(
      private identiteService:  IdentiteService,
      private alertService:     AlertService
  ) { }

  ngOnInit() {
    this.fetchRoles();
  }

  fetchRoles() {
    this.identiteService.getIdentiteByRole(this.aclRole).subscribe(response => {
      if (response.status === 200) {
        this.roles = response.data.map((elem) => new Role(elem));
      } else if (response.message) {
        this.alertService.warn(response.message);
      }
    });
  }

  isExcluded(role: Role) {
    return !!this.toExclude.find((ex) => role.id === ex);
  }

  compareWith(a, b): boolean {
    if (a === 0 && !b) return true;
    return a === b;
  }
}
